import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode:"light",
  },
});

export default theme;